window.dn = window.dn || {};

(function (discussion, $, undefined)
{
    // Look for all of the topics currently listed, and grab their topic id's 
    getCurrentTopicIds = function()
    {
        let topicIds = []
        var topics = $(".dn-topic");

        $.each
        (
            topics, 
            function(index)
            {
                topicIds.push($(topics[index]).data("topic-id"));
            }
        );

        return topicIds;
    }

    /**
     * Add event handlers to a discussion once the messages have been rendered. 
     * This can be called multiple times, such as after dynamically inserting new
     * replies, because we add `dn-event-{event}` classes to each element that we
     * attach an event handler to, so that we don't worry about doing it twice.
     */
    discussion.AddEventHandlers = function() 
    {
        // Vote Button
        $('.btn-vote:not(.dn-event-click)').click
        (
            function(event) 
            {
                var $element = $(this); // referencing this now so we can use it within the callback below, where `this` no longer refers to the element

                if (!dn.user.IsLoggedIn) 
                {
                    dn.PromptToLogin('vote on a message');
                }
                else if (dn.IsDiscussionAnonymized)
                {
                    dn.PromptToSubscribe(dn.CurrentTopicId, 'vote on a message', function(e) { window.location.reload(); });
                }
                else if (dn.message.Current.MissingBadges.length > 0)
                {
                    dn.compose.ShowMissingBadgeModalForTopicAction(dn.message.Current.MissingBadges, "vote on messages");
                }
                else
                {
                    var message = $element.closest('.dn-message');
                    var messageKey = message.data('messagekey');
                    var userKey = message.data('userkey');

                    if (userKey != dn.user.UserKey)
                    {
                        var vote = parseInt($element.data('vote'));
                        dn.message.Vote(messageKey, vote, $element);
                    }
                    else
                    {
                        dn.ShowErrorForElement($element, 'Can\'t vote on your own message.', 'bottom');
                    }
                }
            }
        )
        .addClass("dn-event-click");

        // Bookmark Button
        $('.dn-bookmark:not(.dn-event-click)').click
        (
            function(event)
            {
                var $element = $(this); // referencing this now so we can use it within the callback below, where `this` no longer refers to the element

                if (!dn.user.IsLoggedIn) 
                {
                    dn.PromptToLogin('bookmark a message');
                }
                else if (dn.IsDiscussionAnonymized)
                {
                    dn.PromptToSubscribe(dn.CurrentTopicId, 'bookmark a message', function(e) { window.location.reload(); });
                }
                else if (dn.message.Current.MissingBadges.length > 0)
                {
                    dn.compose.ShowMissingBadgeModalForTopicAction(dn.message.Current.MissingBadges, "bookmark messages");
                }
                else
                {
                    dn.message.Bookmark($element.closest('.dn-message').data('messagekey'), $element);
                }
            }
        )
        .addClass("dn-event-click");

        // Tags
        $('div.dn-tags:not(.dn-event-click)')
        .click(function(event)
        {
            if (!dn.user.IsLoggedIn) 
            {
                dn.PromptToLogin('edit tags');
            }
            else if (dn.IsDiscussionAnonymized)
            {
                dn.PromptToSubscribe(dn.CurrentTopicId, 'edit tags', function(e) { window.location.reload(); });
            }
            else
            {
                dn.tag.EditTags({messageKey: $(this).closest('.dn-message').data('messagekey'), $element: $(this), tagEvent: dn.tag.TagEvent.None});
            }
        })
        .addClass("dn-event-click");

        // Mute Buttons
        $(".dn-mute-message")
        .click
        (
            function()
            {
                var messageKey = $(this).data("messagekey");
                var currentlyMuted = $(this).data("muted") == 'true' || $(this).data("muted") == 'True' || $(this).data("muted") == true;

                // We want to handle the UI for the button vs the anchor in the button drop down a little different
                if ($(this).is(":button")) 
                {
                    dn.message.UpdateMuteUI(messageKey, !currentlyMuted);
                }
                else
                {
                    $(this).data("muted", !currentlyMuted);

                    if (!currentlyMuted) 
                    { 
                        console.log("State Muted - should say unmuted")
                        $('#mute-' + messageKey + " i").addClass('dn-pressed').find('svg[data-fa-i2svg]').attr('data-prefix', 'fas' );
                        $('#mute-' + messageKey + " span").html("Unmute Notifications");
                    }
                    else 
                    {
                        console.log("State Unmuted - should say mute")
                        $('#mute-' + messageKey + " i").removeClass('dn-pressed').find('svg[data-fa-i2svg]').attr('data-prefix', 'far');
                        $('#mute-' + messageKey + " span").html("Mute Notifications");
                    }
                }

                // mute the message (or unmute it if currently muted)
                $.postJSON("/api/v1/message/" + (currentlyMuted ? "unmute/" : "mute/") + messageKey)
                .done()
                .fail
                (
                    function(xhr, textStatus, errorThrown) 
                    {
                        if (!dn.IsErrorHandledAutomatically(null, xhr, null, errorThrown)) 
                        {
                            // The initial request for the message details failed, tell the user
                            var body = dn.FormatApiError(xhr.responseJSON);
                            dn.ShowModal({ title: "Unexpected Error", body: body });
                        }
                    }
                );
            }
        )
        .addClass("dn-event-click");

        // Handle reply filter dropdown clicks
        $('.dn-replyfilter-dropdown .dropdown-item:not(.dn-event-click)')
        .click(discussion.HandleReplyFilter)
        .addClass("dn-event-click");

        // add click-handlers for collapsed replies, to allow expansion
        $("div.dn-reply:not(.dn-event-click)")
        .click
        (
            function(event) 
            {
                if (!dn.user.IsLoggedIn) 
                {
                    dn.PromptToLogin('view replies');
                }
                else if (dn.IsDiscussionAnonymized)
                {
                    dn.PromptToSubscribe(dn.CurrentTopicId, 'view replies', function(e) { window.location.reload(); });
                }
                else if (!dn.user.CanRead)
                {
                    // TODO: Underlying reply data should actually be unavailable
                    dn.PromptToUpgrade("CanReadReplies");
                }
                else if (dn.message.Current.MissingBadges.length > 0)
                {
                    dn.compose.ShowMissingBadgeModalForTopicAction(dn.message.Current.MissingBadges, "view replies");
                }
                else
                {
                    $(this).removeClass("collapse-reply");
                }
            }
        )
        .addClass("dn-event-click");

        // Handle clicks near the top of each reply to collapse the reply
        $('.dn-replytop-spacer:not(.dn-event-click)')
        .click(function(event) 
        {
            $(this).parent().addClass("collapse-reply");
            event.stopPropagation();
        })
        .addClass("dn-event-click");

        $('.reply-author-timestamp:not(.dn-event-click)')
        .click(function(event) 
        {
            // only trigger when they aren't clicking on underlying divs, like the author name or timestamp
            var $dnreply = $(this).parents(".dn-reply").first();

            if ($dnreply)
            {
                if ($dnreply.hasClass("collapse-reply"))
                {
                    if (!dn.user.IsLoggedIn) 
                    {
                        dn.PromptToLogin('view replies');
                    }
                    else
                    {
                        $dnreply.removeClass("collapse-reply");
                    }
                }
                else if (event.target.className == 'reply-author-timestamp')
                {
                    $dnreply.addClass("collapse-reply");
                }
            }

            event.stopPropagation();
        })
        .addClass("dn-event-click");

        // wire up any share buttons
        $(".dn-share:not(.dn-event-click)").click
        (
            function(e)
            {
                e.preventDefault();

                var $element = $(this); // referencing this now so we can use it within the callback below, where `this` no longer refers to the element

                if (dn.user.IsLoggedIn)
                {
                    if (dn.message.Current.MissingBadges.length > 0)
                    {
                        dn.compose.ShowMissingBadgeModalForTopicAction(dn.message.Current.MissingBadges, "share messages");
                    }
                    else
                    {
                        var messageKey = $element.data("messagekey");
                        var $message = $("div.dn-message[data-messagekey=" + messageKey + "]");
                        var title;
                        var snippet;

                        if ($message.data("sequence") == "0" && $message.data("depth") == "0")
                        {
                            // this is the root
                            title = $("#dn-discussion-title").text();
                            snippet = $("meta[name=description]").attr("content");
                        }
                        else
                        {
                            title = "Re: " + $("#dn-discussion-title").text();
                            snippet = $message.find("div.reply-body > p:first").html()
                        }

                        dn.Share
                        ({
                            author: $message.data("authorname"),
                            profilePhoto: messageKey ? $("#dn-profile-photo-" + messageKey).attr("src") : null,
                            messageKey: messageKey,
                            snippet: snippet,
                            title: title,
                            url: $element.data("url")
                        });
                    }
                }
                else
                {
                    dn.PromptToLogin('share messages');
                }
            }
        )
        .addClass("dn-event-click");

        // NOTE THIS IS HITTING ALL ANCHORS WHICH HAVE NOT ALREADY BEEN TOUCHED
        // DROPDOWN 'BUTTONS' ARE ANCHORS SO THIS SHOULD BE LAST
        // don't let clicks on links work when the reply is collapsed
        $('.dn-reply a:not(.dn-event-click,.dropdown-item)')
        .click(function(event) 
        {
            var $dnreply = $(this).parents(".dn-reply").first();

            if ($dnreply && $dnreply.hasClass("collapse-reply"))
            {
                if (!dn.user.IsLoggedIn) 
                {
                    dn.PromptToLogin('view replies');
                }
                else
                {
                    $dnreply.removeClass("collapse-reply");
                }

                return false;
            }
        })
        .addClass("dn-event-click");
    };

    /**
     * This will handle user-requested changes in the reply filtering.
     * 
     * @param {event} event - Change event for the reply filter dropdown.
     */
    discussion.HandleReplyFilter = function(event)
    {
        if (!dn.user.IsLoggedIn) {
            dn.PromptToLogin('filter replies');
            return;
        }

        var replyFilterMinutes = $(this).data('minutes');
        var replyFilterDisplay = $(this).data('display');
        $('span.dn-replyfilter-display').text(replyFilterDisplay).val(replyFilterMinutes);

        $(this).parent().find('.dropdown-item.dropdown-selected').removeClass("dropdown-selected");
        $(this).addClass("dropdown-selected");

        if (replyFilterMinutes == 0)
        {
            // Expand all replies updated since last visit (except muted)
            // First collapse all replies not already collapsed
            $('.dn-reply:not(.collapse-reply)').addClass('collapse-reply');

            // Now Expand all replies that have come in since last visit
            var milliseconds = parseInt($('.dn-message').data("lastvisit"));
            $('.dn-reply.collapse-reply:not(.dn-muted)').filter(function() {
                return $(this).data("updated") > milliseconds;
            }).removeClass("collapse-reply");
        }
        else if (replyFilterMinutes == -1) // Expand all replies (except muted)
        {
            // first collapse all replies that are expanded
            $('.dn-reply:not(.collapse-reply)').addClass('collapse-reply');

            // Expand all replies 
            $('.dn-reply.collapse-reply:not(.dn-muted)').removeClass('collapse-reply');
        }
        else if (replyFilterMinutes == -2) // Expand all replies including muted
        {
            // expand everything
            $('.dn-reply.collapse-reply').removeClass('collapse-reply');
            discussion.ShowMutedReplies();
        }
        else // everything but the "all replies" option, no muted replies expanded
        {
            // Expand all replies made since the given # of minutes ago.
            // `milliseconds` holds a timestamp that represents X minutes ago, where X is 
            // the number of minutes chosen from the reply filter dropdown. We then
            // use this timestamp to filter down to just the replies posted SINCE.
            var milliseconds = (new Date()).getTime() - (replyFilterMinutes * 60000) - 1000;

            // first collapse all replies that are expanded
            $('.dn-reply:not(.collapse-reply)').addClass('collapse-reply');

            // expand the replies updated since timestamp
            $('.dn-reply.collapse-reply:not(.dn-muted)').filter(function() {
                return $(this).data("updated") > milliseconds;
            }).removeClass("collapse-reply");
        }

        var firstExpandedReply = $('.dn-reply').not('.collapse-reply').first();
        if (firstExpandedReply.length != 0)
        {
            // Scroll down to the first expanded reply, if there is one
            $('html, body').animate({
                scrollTop: firstExpandedReply.offset().top - 50
            }, 750);
        }
    };

    /**
     * Called in the $.ready of any page that needs to use the dn.discussion code.
     */
    discussion.Init = function()
    {
        discussion.AddEventHandlers();

        dn.QueueFunction
        (
            'dn.compose', 
            function()
            {
                dn.compose.Init();
            }
        );

        if (dn.IsDiscussionAnonymized)
        {
            // User reading a discussion posted to a group they aren't subscribed to.
            // If they click a file, prompt them to subscribe to the group.
            $(".dn-file-wrapper:not(.dn-event-click)").click(function(e) 
            {
                dn.PromptToSubscribe(dn.CurrentTopicId, 'view attachments', function(e) { window.location.reload(); });
            })
            .addClass("dn-event-click");
        }
        else
        {
            dn.QueueFunction
            (
                'dn.message',
                function()
                {
                    dn.message.AddEventHandlers();
                }
            );

            // Don't immediately scroll if there are some embeds on the page, giving our iframely
            // embedder a chance to format the page to the right length. 
            // TODO: Is there a way to immediately scroll to reply, but adjust, if needed, when embeds are displayed?
            if ($("oembed[url]").length === 0 && $("[data-iframely-url]").length === 0 && $("iframe[src*='iframe.ly']").length === 0)
            {
                dn.QueueFunction
                (
                    'dn.message',
                    function()
                    {
                        dn.message.ScrollToReply();
                    }
                );
            }
            else
            {
                dn.QueueFunction
                (
                    'dn.message',
                    function()
                    {
                        setTimeout(dn.message.ScrollToReply, 1500); // delayed scroll, hopefully to coalesce with any frame height changes
                    }
                );
            }
        }
    };

    /**
     * Dynamically process the replies shown on this discussion, adding dn-muted class to all the replies 
     * from users that the CurrentUser has muted, as well as any replies made in those sub-threads (assuming
     * `DiscussionSubthreadShow` flag is false).
     */
    discussion.ProcessMutedReplies = function()
    {
        dn.message.Current.NumMuted = 0;

        // Set and retain depth and sequence until depth < the set depth and then conintue
        var no_depth = -1;
        var muteTargetDepth = no_depth;
        var showSubreply = false;

        $(".dn-reply").each(function(index)
        {
            var $message = $(this);
            var currentDepth = parseInt($message.data("depth"));
            var authorKey = $message.data("userkey");
            var messageKey = $message.data("messagekey");
            var status = parseInt($message.data("status"));

            var parentMessageKey = $message.data("parentkey");
            var parentUserKey = $("#" + parentMessageKey).data("userkey");

            // Reset on messages which have the same or less depth than the target
            if (currentDepth <= muteTargetDepth)
            {
                muteTargetDepth = no_depth;
                showSubreply = false;
            }

            if (authorKey in dn.user.MutedUsers)
            {
                // This author is being muted

                // Since we're muting this user we want to decide whether or not to show this reply. 
                // If they do NOT have the DiscussionReplyShow flag set, AND this reply is not a reply
                // made directly to the viewing user, OR it is a direct reply and they do NOT have
                // the DiscussionDirectReplyShow flag set, then we hide it. We'll set muteTargetDepth
                // if needed, and the classes to hide the message.
                if (!dn.HasFlag(dn.user.MutedUsers[authorKey], dn.constants.MuteFlags.DiscussionReplyShow) && (parentUserKey !== dn.user.UserKey || !dn.HasFlag(dn.user.MutedUsers[authorKey], dn.constants.MuteFlags.DiscussionDirectReplyShow)))
                {
                    // Set the muted depth, but if it was already set, don't set it 
                    // again so we don't un-set it when coming back out of a tree of replies
                    if (muteTargetDepth === no_depth)
                    {
                        muteTargetDepth = currentDepth;
                    }

                    $message.addClass("dn-muted dn-hide-reply collapse-reply");
                    dn.message.Current.NumMuted++;
                }

                // If the user has set the flag to show the subreplies to muted messages (per user, or globally)
                if (dn.HasFlag(dn.user.MutedUsers[authorKey], dn.constants.MuteFlags.DiscussionSubthreadShow))
                {
                    showSubreply = true;
                }
            }
            // If the reply has a default status and is below our threshold, mute it (collapse it and all possibly replies to it)
            else if (status === 0 && $("#data-" + messageKey).data("votetotal") < dn.constants.ThresholdReplyVoteMinimum)
            {
                // Set the muted depth, but if it was already set, don't set it 
                // again so we don't un-set it when coming back out of a tree of replies
                if (muteTargetDepth === no_depth)
                {
                    muteTargetDepth = currentDepth;
                }

                $message.addClass("dn-muted dn-hide-reply collapse-reply");
                dn.message.Current.NumMuted++;

                // If the user has set the flag to show the subreplies to muted messages (globally)
                if (dn.HasFlag(dn.user.MuteSettings, dn.constants.MuteFlags.DiscussionSubthreadShow))
                {
                    showSubreply = true; 
                }
            }
            // If we're not showing subreplies, and the depth is greater than the target depth, hide it 
            else if (!showSubreply && muteTargetDepth !== no_depth && status === 0)
            {
                $message.addClass("dn-muted dn-hide-reply collapse-reply");
                dn.message.Current.NumMuted++;
            }
        });
    };


    /**
     * A landing for the #action flow.
     * 
     * @param {string}  messageKey            - The discussionKey to mute, should be this discussion 
     */
    discussion.PromptMuteDiscussion = function(messageKey) 
    {
        var targetMessageKey = messageKey;

        // If we have not been passed a specific message, we are going to mute the whole discussion
        if (!targetMessageKey)
        {
            targetMessageKey = $(".dn-root-message").data("messagekey");
        }

        var id = 'dn-mute-discussion-prompt';
        $('#' + id).remove();  // remove if it already exists

        $("body").append($('<div class="modal dn-mute-discussion-prompt" tabindex="-1" role="dialog" style="display: none" id="' + id + '">\
            <div class="modal-dialog" role="document">\
                <div class="modal-content">\
                    <div class="modal-header">\
                        <h5 class="modal-title"><b>Are you sure?</b></h5>\
                        <button type="button" class="close dn-mute-discussion-prompt-close" data-dismiss="modal" aria-label="Close">\
                        <span aria-hidden="true">&times;</span>\
                        </button>\
                    </div>\
                    <div class="modal-body" style="background-color: #f8f9fa; padding-bottom: 0">\
                        <div class="">' +                                                       
                            '<div class="col-12 col-xl px-0">\
                                <label>This will mute replies to this ' + (messageKey?'message':'discussion') + '.\
                                 You will not receive any emails or notifications for future replies.</label>\
                            </div>\
                        </div>\
                    </div>\
                    <div class="modal-footer" style="background-color: #f8f9fa; border-top: none">\
                        <button type="button" class="btn btn-primary " id="dn-mute-discussion-confirm-button">Mute ' + (messageKey?'Message':'Discussion')  + '</button>\
                        <button type="button" class="btn btn-secondary dn-mute-discussion-prompt-close">Cancel</button>\
                    </div>\
                </div>\
            </div>\
        </div>'));

        // stop any spinners before showing our new one
        dn.Spin(false);

        // remember the modals that were already open before us, so we can show them when done. 
        var openModals = $('.modal.show');
        openModals.modal('hide');

        $("#"+id).modal();

        // Close button clicked
        $('.dn-mute-discussion-prompt-close').click
        (
            function(event) 
            {
                $("#"+id).modal('hide');
                openModals.modal('show'); // re-show modals that were open when we first appeared
            }
        );

        // Mute button clicked
        $('#dn-mute-discussion-confirm-button').click
        (
            function () 
            {
                dn.Spin(true);

                $.postJSON("/api/v1/message/mute/" + targetMessageKey)
                .always
                (
                    function() 
                    {
                        dn.Spin(false);
                        // Mute that specific message 
                        if (messageKey) 
                        {
                            dn.message.UpdateMuteUI(messageKey, true);
                        }
                        // Else we are muting the discussion
                        else 
                        {
                            $("#mute-" + targetMessageKey).data("muted", true)
                            $('#mute-' + targetMessageKey + " i").addClass('dn-pressed').find('svg[data-fa-i2svg]').attr('data-prefix', 'fas' );
                            $('#mute-' + targetMessageKey + " span").html("Unmute Notifications");
                        }
                    }
                )
                .done(
                    function()
                    {
                       // Hide the PM modal dialog
                       $("#"+id).modal('hide');
                    }
                )
                .fail(function(xhr, textStatus, errorThrown) 
                {
                    dn.compose.HandleErrors($("#"+id), xhr, textStatus, errorThrown);
                });
            }
        );

        // It's showtime!
        $("#"+id).modal('show');
    };


    /**
     * When called, we'll build a "call to action" banner that will be prepended to the given element.
     * We use this when someone isn't currently eligible to participate in a discussion, letting them 
     * know why and what they need to do to fix it.
     */
    discussion.ShowCallToAction = function(opt)
    {
        var bannerHTML = '<div class="alert alert-success dn-anonymized-warning dn-banner col-12 col-md-8" role="alert">\
            <h4 class="alert-heading">' + opt.title + '</h4>\
            <p>' + opt.htmlContent + '</p>\
            <button class="btn btn-success" id="btn-participation-banner-positive">' + opt.buttonText + '</button>' + 
            (opt.altPromptText ? ('<button class="btn btn-link text-success " id="btn-alt-prompt">' + opt.altPromptText + '</button>') : '') + 
        '</div>';
        
        // Add the banner wherever we wanted it
        $(bannerHTML).insertBefore(opt.$element);
        
        // attach the click listeners
        $("#btn-participation-banner-positive").click(opt.buttonFunction);
        
        if (opt.altPromptFunction)
        {
            $("#btn-alt-prompt").click(opt.altPromptFunction);
        }
    };

    /**
     * Toggle muted replies so that they are first shown and highlighted, then upon second click expanded if
     * any were collapsed, then upon third click, collapsed again and re-highlighted each time. 
     */
    discussion.ShowMutedReplies = function()
    {
        // If they've activated ShowMuteReplies 3x, then we reset and re-collapse
        $shownTwice = $('.dn-reply.dn-muted.dn-muted-shown.dn-muted-shown-twice');

        if ($shownTwice.length > 0)
        {
            $shownTwice.removeClass('dn-muted-shown-twice dn-highlight-to-dn-message').each
            (
                function() 
                {
                    void this.offsetWidth; // force reflow so highlight animation can be repeated, if necessary
                }
            );
            $shownTwice.addClass("dn-highlight-to-dn-message collapse-reply");
        }
        else
        {
            // If they've activate ShowMutedReplies more than once, then this line will expand them (due to presence of dn-muted-shown class).
            $('.dn-reply.dn-muted.collapse-reply.dn-muted-shown').removeClass('collapse-reply dn-highlight-to-dn-message').addClass("dn-muted-shown-twice").each
            (
                function() 
                {
                    void this.offsetWidth; // force reflow so highlight animation can be repeated, if necessary
                }
            );

            // Show the hidden muted replies, and highlight them.
            $(".dn-muted").removeClass("dn-hide-reply dn-highlight-to-dn-message").addClass("dn-highlight-to-dn-message dn-muted-shown");
        }
    };

    $(document).ready
    (
        function ($)
        {
            // Process any queued functions now that the namespace is ready.
            dn.ProcessQueuedFunctions('dn.discussion');
        }
    );

}(window.dn.discussion = window.dn.discussion || {}, jQuery));
